module.exports = __webpack_public_path__ + "static/media/elevated-photo-product.1a4b5b86.jpg";